export function isIsin(query: string): boolean {
  const isinRegex = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/;
  return isinRegex.test(query) || (query.startsWith('MOCKISIN') && query.length === 12);
}
